/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateCoupangInfoVo } from './UpdateCoupangInfoVo';
import {
    UpdateCoupangInfoVoFromJSON,
    UpdateCoupangInfoVoFromJSONTyped,
    UpdateCoupangInfoVoToJSON,
    UpdateCoupangInfoVoToJSONTyped,
} from './UpdateCoupangInfoVo';

/**
 * 
 * @export
 * @interface ResponseUpdateCoupangInfoVo
 */
export interface ResponseUpdateCoupangInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUpdateCoupangInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUpdateCoupangInfoVo
     */
    message?: string;
    /**
     * 
     * @type {UpdateCoupangInfoVo}
     * @memberof ResponseUpdateCoupangInfoVo
     */
    data?: UpdateCoupangInfoVo;
}

/**
 * Check if a given object implements the ResponseUpdateCoupangInfoVo interface.
 */
export function instanceOfResponseUpdateCoupangInfoVo(value: object): value is ResponseUpdateCoupangInfoVo {
    return true;
}

export function ResponseUpdateCoupangInfoVoFromJSON(json: any): ResponseUpdateCoupangInfoVo {
    return ResponseUpdateCoupangInfoVoFromJSONTyped(json, false);
}

export function ResponseUpdateCoupangInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUpdateCoupangInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UpdateCoupangInfoVoFromJSON(json['data']),
    };
}

export function ResponseUpdateCoupangInfoVoToJSON(json: any): ResponseUpdateCoupangInfoVo {
    return ResponseUpdateCoupangInfoVoToJSONTyped(json, false);
}

export function ResponseUpdateCoupangInfoVoToJSONTyped(value?: ResponseUpdateCoupangInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UpdateCoupangInfoVoToJSON(value['data']),
    };
}

